<template>
  <div class="azcon-training-card-skeleton">
    <div class="azcon-training-card-skeleton__image"></div>
    <div class="azcon-training-card-skeleton__title"></div>
  </div>
</template>

<script>
export default {
  name: "AzconTrainingCardSkeleton",
};
</script>

<style lang="scss" scoped>
.azcon-training-card-skeleton {
  &__image {
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 10px;
    background: linear-gradient(90deg, #e8edf3 25%, #dce3eb 50%, #e8edf3 75%);
    background-size: 200% 100%;
    animation: azcon-shimmer 1.5s infinite;
  }

  &__title {
    margin-top: 6px;
    width: 70%;
    height: 12px;
    border-radius: 4px;
    background: linear-gradient(90deg, #e8edf3 25%, #dce3eb 50%, #e8edf3 75%);
    background-size: 200% 100%;
    animation: azcon-shimmer 1.5s infinite;
  }
}

@keyframes azcon-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
